import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function Footer() {
  const date = new Date();
  const year = date.getFullYear();

  return (
    <Container fluid className="footer">
      <Row>
        <Col md='4' className='footer-copywright' />
        <Col md='4' className='footer-copywright'>
          <h3>Nicoletta Papakonstantinou © {year}</h3>
        </Col>
        <Col md='4' className='footer-body'>
          <ul className='footer-icons' />
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
